module.exports = __webpack_public_path__ + "img/product4.eefd75a2.png";